import styled, { css } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  AI_GRADIENT,
  AI_PINK,
  AI_TOOLBAR_ACTION_HEIGHT,
} from './aiEvaluationTokens'

const gradientText = css`
  background: ${AI_GRADIENT};
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`

export const ToolbarButton = styled.button<{ $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: ${AI_TOOLBAR_ACTION_HEIGHT};
  min-height: ${AI_TOOLBAR_ACTION_HEIGHT};
  padding: 12px 16px;
  margin-right: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 2px solid ${AI_PINK};
  background: #ffffff;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  transition: opacity 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    opacity: 0.9;
    box-shadow: 0 2px 8px rgba(255, 93, 44, 0.18);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 93, 44, 0.25);
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      background: #f0f0f0;
      border-color: #f0f0f0;
      cursor: not-allowed;
      pointer-events: none;
      box-shadow: none;
    `}
`

export const ToolbarIcon = styled(FontAwesomeIcon)<{ $disabled?: boolean }>`
  height: 16px !important;
  width: 16px !important;

  path {
    fill: ${({ $disabled }) =>
      $disabled ? '#757575' : 'url(#rankmiAiGradient)'};
  }
`

export const ToolbarLabel = styled.span<{ $disabled?: boolean }>`
  ${({ $disabled }) =>
    $disabled
      ? css`
          background: none;
          -webkit-text-fill-color: #757575;
          color: #757575;
        `
      : gradientText}
`
